/**
 * Highest navigable spread index: the explicit `maxSpreadIndex` when given (including 0), else
 * derived from the page count (`floor(totalPages / 2)`, 0 before pages load).
 */
export function resolveMaxSpreadIndex(
  maxSpreadIndexProp: number | undefined,
  safeTotalPages: number
): number {
  const lastContentSpreadIndex = safeTotalPages > 0 ? Math.floor(safeTotalPages / 2) : 0

  if (typeof maxSpreadIndexProp === 'number') return Math.max(0, maxSpreadIndexProp)

  return safeTotalPages > 0 ? lastContentSpreadIndex : 0
}

export function clampSpreadIndex(spreadIndex: number, maxSpreadIndex: number): number {
  return Math.min(Math.max(0, spreadIndex), maxSpreadIndex)
}
